"use client";
import useInfiniteFeedPosts from "../hooks/useInfiniteFeedPosts";
import { FeedPost } from "../FeedPost";
import FeedRepost from "../FeedRepost";
import { ShowMoreButton } from "@/app/(components)/Basic/ShowMoreButton";
import SatelliteIcon from "@/assets/icons/satellite.svg";
import Link from "next/link";
import { FeedArtOrderPost } from "../FeedArtOrderPost";
import { FeedType } from "@/api/posts/types";

export interface Props {
  feedType: FeedType;
}

export default function FeedList({ feedType }: Props) {
  const { posts, fetchNextPage, hasNextPage } = useInfiniteFeedPosts(feedType);

  if (!posts || !posts.length) {
    return (
      <div className="mb-16 md:mb-40 flex items-center mx-auto">
        <SatelliteIcon className="w-6 fill-endemicGray-700 endemic:fill-primary mr-2" />
        <span className="text-body-3 text-primary font-semibold">
          Nothing to see here.
          {feedType === FeedType.MY && (
            <>
              {" "}
              Start following some{" "}
              <Link href="/artists" className="text-red endemic:text-yellow">
                artist
              </Link>
              .
            </>
          )}
        </span>
      </div>
    );
  }

  return (
    <div className="mb-16 md:mb-20">
      <ul className="flex flex-col gap-4 md:gap-6">
        {posts.map((post) =>
          !!post.repost ? (
            <FeedRepost key={post.id} feedPost={post} />
          ) : post.artOrder ? (
            <FeedArtOrderPost key={post.id} feedPost={post} />
          ) : (
            <FeedPost key={post.id} feedPost={post} />
          ),
        )}
      </ul>
      {hasNextPage && (
        <ShowMoreButton
          fetchNextPage={fetchNextPage}
          className="mt-8 md:mt-20"
        />
      )}
    </div>
  );
}
